import { render, staticRenderFns } from "./RdigLayout.vue?vue&type=template&id=35d2ddb0&scoped=true&"
import script from "./RdigLayout.vue?vue&type=script&lang=js&"
export * from "./RdigLayout.vue?vue&type=script&lang=js&"
import style0 from "./RdigLayout.vue?vue&type=style&index=0&id=35d2ddb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d2ddb0",
  null
  
)

export default component.exports